import { OnInit, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, Validators } from '@angular/forms';
import { first } from 'rxjs/operators';
import { AuthenticationService } from '../_services';
var LoginComponent = /** @class */ (function () {
    function LoginComponent(formBuilder, route, router, authenticationService) {
        this.formBuilder = formBuilder;
        this.route = route;
        this.router = router;
        this.authenticationService = authenticationService;
        this.loading = false;
        this.submitted = false;
    }
    LoginComponent.prototype.ngOnInit = function () {
        this.loginForm = this.formBuilder.group({
            username: ['', Validators.required],
            password: ['', Validators.required]
        });
        // get return url from route parameters or default to '/'
        this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
    };
    LoginComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        // reset login status
        setTimeout(function () {
            _this.authenticationService.logout();
        });
        google.accounts.id.initialize({
            client_id: "81881082439-tqbtqf24dqvoj9r74imo7qb66lo75kb2.apps.googleusercontent.com",
            callback: this.onSignIn.bind(this)
        });
        google.accounts.id.renderButton(document.getElementById("g_id_signin"), { type: "standard", text: "signin_with", theme: "outline",
            size: "medium", width: "250" });
        google.accounts.id.prompt(); // also display the One Tap dialog
    };
    Object.defineProperty(LoginComponent.prototype, "f", {
        // convenience getter for easy access to form fields
        get: function () {
            return this.loginForm.controls;
        },
        enumerable: true,
        configurable: true
    });
    LoginComponent.prototype.onSubmit = function () {
        var _this = this;
        this.submitted = true;
        console.log('Submit form login');
        // stop here if form is invalid
        if (this.loginForm.invalid) {
            return;
        }
        this.loading = true;
        this.authenticationService
            .login(this.f.username.value, this.f.password.value)
            .pipe(first())
            .subscribe(function (data) {
            if (data.id) {
                _this.router.navigate([_this.returnUrl]);
            }
            else {
                alert('Usuario o contraseña no válido: ' + data.message);
            }
        }, function (error) {
            _this.loading = false;
        });
    };
    LoginComponent.prototype.onSignIn = function (response) {
        var _this = this;
        var base64Url = response.credential.split('.')[1];
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
        var responsePayload = JSON.parse(jsonPayload);
        var user = {};
        var that = this;
        // const auth2 = gapi.auth2.getAuthInstance();
        var username;
        (function (u, p) {
            u['id'] = p.sub;
            u['name'] = p.name;
            u['email'] = p.email;
            u['imageUrl'] = p.picture;
            u['givenName'] = p.given_name;
            u['familyName'] = p.family_name;
            u['token'] = response.credential;
        })(user, responsePayload);
        this.authenticationService.verifyToken(user['token']).subscribe(function (data) {
            console.log(data);
            that.userData = data;
            username = that.userData.username;
            that.userData.googleUser = user;
            if (!(that.userData.creado == null)) {
                if (that.userData.creado) {
                    alert('¡Gracias por registrarte! Estamos procesando tus datos.');
                }
                else {
                    alert('Su usuario ' +
                        username +
                        ' se encuentra deshabilitado. Deberá esperar que sea autorizado por los administradores.');
                }
                // auth2.signOut().then(function() {
                //   console.log('User signed out.');
                // });
            }
            else {
                // login successful if there's a jwt token in the response
                that.authenticationService.loguearUsuario(that.userData);
                _this.router.navigate(['/inicio']);
            }
        });
        console.log(user);
        // user.save();
        // this.goHome();
    };
    return LoginComponent;
}());
export { LoginComponent };
